module.exports = __webpack_public_path__ + "static/mfdf_home-5a50f93a5050dba616b411ee27632cb2.png";